import React from 'react';
import { DATETIME_FORMAT } from '../shared/constants';
import dayjs from 'dayjs';

const OrderAssignedToast = ({ order }) => {
    const handleOrderClick = (e) => {
        e.preventDefault();
        window.location.href = `/order/${order.id}`;
    };

    const handleDriverClick = (e) => {
        e.preventDefault();
        window.location.href = `/driver/detail/${order.driverDetails._id}`;
    };

    return (
        <div className="d-flex flex-wrap align-items-center">
            <span className="me-1">a</span>
            <a
                href={`/order/${order?.id}`}
                onClick={handleOrderClick}
                className="text-primary text-decoration-underline fw-bold mx-1"
                style={{ cursor: 'pointer' }}
            >
                order
            </a>
            <span className="mx-1">assigned to</span>
            <a
                href={`/driver/detail/${order?.driverDetails?._id}`}
                onClick={handleDriverClick}
                className="text-primary text-decoration-underline fw-bold mx-1"
                style={{ cursor: 'pointer' }}
            >
                {order?.driverDetails?.firstName} {order?.driverDetails?.lastName}
            </a>
            <span className="ms-1 text-muted small">
                on {dayjs(order?.updatedAt).format(DATETIME_FORMAT)}
            </span>
        </div>
    );
};

export default OrderAssignedToast;
